/** /connections keeps its backend funnel (connect_surface_clicked {cta}) — the wizard's clicks
 *  mapped onto the names it always used. Views, passive and automatic events are not clicks. */
export function connectSurfaceCta(name: string, props?: Record<string, unknown>): string | null {
  if (props?.auto) return null;
  switch (name) {
    case 'onboarding_extension_clicked': return 'download_extension';
    case 'onboarding_whatsapp_web_clicked': return 'open_wa_web';
    case 'onboarding_path_chosen': return props?.path === 'remote' ? 'remote_connection' : 'local_connection';
    case 'onboarding_remote_started': return 'create_remote';
    case 'onboarding_trial_clicked': return 'start_trial';
    case 'onboarding_extension_link': return 'link_extension';
    case 'onboarding_first_message_scheduled': return 'send_test';
    default: return null;
  }
}
